import { useCallback, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { updateBooking as updateBookingAction } from "app/pages/Booking/bookingActionCreators";
import { FLIGHT_OPTIONS_STATUS } from "app/constants";
import { getTransfersOfSelectedFlight } from "app/pages/Booking/Quotation/quotationSelectors.js";
import QuotationTransfers from "app/pages/Booking/Quotation/Transfer/QuotationTransfers";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import useOnScreen from "app/pages/.shared/useOnScreen";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const QuotationTransfersContainer = () => {
	const transfers = useSelector(getTransfersOfSelectedFlight) || [];
	const isLoading = useSelector(
		state => state.quotation.flightOptionsStatus === FLIGHT_OPTIONS_STATUS.LOADING
	);

	const dispatch = useDispatch();
	const updateBooking = useCallback(
		(...args) => dispatch(updateBookingAction(...args)),
		[dispatch]
	);

	/**
	 * Condition pour cacher le block transfer :
	 * - n'avoir qu'un seul transfert ayant le code 'NO_TRANSFER'
	 */
	const shouldDisplayTransfers =
		(transfers && transfers.length > 1) ||
		(transfers.length === 1 && transfers[0].code !== "NO_TRANSFER");

	const { track } = useAnalytics();
	const ref = useRef();
	const isElementOnScreen = useOnScreen({ ref, triggerOnce: false });

	useEffect(() => {
		if (isElementOnScreen && !isLoading && shouldDisplayTransfers) {
			track("quote_view_transfert");
		}
	}, [isElementOnScreen, isLoading, shouldDisplayTransfers]);

	const onTransferSelection = useCallback(transfer => {
		updateBooking({
			transfer: transfer,
		});
		track("quote_click_transfer", {
			includedTransfer: transfer.included,
			transferCode: transfer.code,
			transferQuantity: transfer.quantity,
		});
	}, []);

	return (
		shouldDisplayTransfers &&
		isLoading === false && (
			<div className="quotation-transferts quotation__item">
				<FormattedMessage id="quotation.transfer.title">
					{message => (
						<div className="quotation__headline">
							<Typography
								variant={TYPOGRAPHY_VARIANTS.XL3}
								variantMD={TYPOGRAPHY_VARIANTS.XL4}
								isBold
								className="quotation__title"
								component="h2"
							>
								{message}
							</Typography>
						</div>
					)}
				</FormattedMessage>

				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					className="quotation__description"
					component="p"
				>
					<FormattedMessage id="quotation.transfer.description" />
				</Typography>
				<div className="quotation__content" ref={ref}>
					<QuotationTransfers transfers={transfers} onChange={onTransferSelection} />
				</div>
			</div>
		)
	);
};

export default QuotationTransfersContainer;
